import React, { FC } from 'react';

import graphicSVG from 'assets/images/registry/start-registry-graphic.svg';

import { Graphic, GraphicContainer } from './StartRegistryGraphic.styles';

const StartRegistryGraphic: FC = () => {
  // Variables + State
  const altText =
    'All of your, Gifts, Cash Funds, Gift Cards, Experiences, from Zola or any store will appear here as you add them';

  // Methods

  // Event Handlers

  // Render
  return (
    <GraphicContainer>
      <Graphic src={graphicSVG} alt={altText} />
    </GraphicContainer>
  );
};

export default StartRegistryGraphic;
